import { register } from 'register-service-worker';
import { Toaster } from './toast';

export class ErrorHandler {
    public static errorResponseHandler(error: any) {
        // if has response show the error
        if (error.response.status === 500) {
            window.HideLoader();
            Toaster.error('حدث خطأ في النظام');
            return Promise.reject(error);
        } else if (error.response.status === 409) {
            window.HideLoader();
            Toaster.error(error.response.data);
            return Promise.reject(error);
        }else if (error.response.status === 400) {
            window.HideLoader();
            if (typeof error.response.data === 'string') {
                if (error.response.data != '') {
                    Toaster.error(error.response.data);
                }
            } else {
                Toaster.error('حدث خطأ في النظام');
            }
            return Promise.reject(error);
        }
         else if (error.response.status === 404) {
            window.HideLoader();
            if (typeof error.response.data === 'string') {
                if (error.response.data != '') {
                    Toaster.error(error.response.data);
                }
                else {
                    Toaster.error('حدث خطأ في النظام');
                }
                return Promise.reject(error);

            } 
            // else{
            //     window.HideLoader();
            //     Toaster.error(error.response.data);
            //     return Promise.reject(error);
            // }
        }
    }
}